import { useMemo, useContext, createContext } from 'react';
import { toast, ToastContainer } from 'react-toastify';

const ToastContext = createContext({
  showToast: (message: string, type?: 'success' | 'error' | 'info' | 'warning') => {},
});

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const showToast = useMemo(
    () =>
      (message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info') => {
        toast[type](message);
      },
    [toast]
  );

  const value = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={value}>
      <ToastContainer position="top-right" autoClose={3000} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
